import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
      fill="#27272A"
    />
    <path
      d="M4.73767 13.6143C4.61079 13.4032 4.49741 13.1841 4.39831 12.9585C3.89268 11.7713 3.86751 10.4329 4.32818 9.22739C4.78886 8.02185 5.69916 7.04403 6.8658 6.50148C7.59466 6.18678 8.38815 6.05264 9.17942 6.11035C9.97069 6.16805 10.7366 6.4159 11.4126 6.83304C12.3447 7.40122 13.0592 8.26803 13.4411 9.29381C13.5019 9.44014 13.5573 9.59387 13.6117 9.72723L4.73767 13.6143ZM7.7012 8.42787C7.20083 8.63641 6.78361 9.00598 6.51507 9.47854C6.24653 9.9511 6.14188 10.4999 6.21758 11.0387L10.6795 9.10857C10.342 8.66133 9.8582 8.34822 9.31325 8.22452C8.76831 8.10081 8.19733 8.17449 7.7012 8.43251V8.42787ZM11.2355 12.627L11.1433 12.564C10.8546 13.0196 10.4337 13.3752 9.93727 13.5828C9.52849 13.8002 9.06481 13.8913 8.60459 13.8447C8.14437 13.798 7.70812 13.6157 7.35081 13.3207L7.28991 13.4133L6.15758 15.1155C6.43926 15.3114 6.74066 15.4772 7.0567 15.6101C8.10018 16.0318 9.25616 16.0808 10.3313 15.7491C11.4065 15.4173 12.3357 14.7248 12.9635 13.7874L11.2355 12.627Z"
      fill="white"
    />
    <path
      d="M16.7119 4V13.4587L18.1772 14.0551L17.3473 16L15.7309 15.3239C15.4064 15.1818 15.13 14.9483 14.9351 14.6515C14.7194 14.3 14.6111 13.8927 14.6235 13.48V4H16.7119Z"
      fill="white"
    />
    <path
      d="M20.5046 11.0531C20.5045 10.6703 20.5861 10.292 20.744 9.94371C20.902 9.59539 21.1326 9.2852 21.4202 9.0341L19.9172 7.35132C19.3957 7.81494 18.9781 8.38449 18.6921 9.02232C18.4061 9.66015 18.2583 10.3517 18.2583 11.0512C18.2583 11.7508 18.4061 12.4423 18.6921 13.0801C18.9781 13.718 19.3957 14.2875 19.9172 14.7512L21.4184 13.0684C21.1316 12.8175 20.9016 12.5078 20.744 12.1602C20.5864 11.8126 20.5048 11.4351 20.5046 11.0531Z"
      fill="#00A4E0"
    />
    <path
      d="M23.1776 13.7333C22.8898 13.7326 22.6039 13.6854 22.3311 13.5934L21.6138 15.7356C22.2739 15.9575 22.9733 16.0364 23.666 15.967C24.3587 15.8976 25.0289 15.6815 25.6324 15.333C26.2359 14.9844 26.7589 14.5113 27.167 13.9448C27.5751 13.3784 27.8591 12.7315 28.0001 12.0468L25.7944 11.5939C25.6706 12.1988 25.3427 12.7422 24.8658 13.1321C24.3889 13.522 23.7925 13.7344 23.1776 13.7333Z"
      fill="#EF4123"
    />
    <path
      d="M23.1803 6.10956C22.6502 6.10928 22.1234 6.19433 21.6201 6.36147L22.331 8.50549C22.6897 8.3862 23.0695 8.3446 23.4454 8.38345C23.8212 8.42229 24.1845 8.54069 24.5115 8.73083C24.8385 8.92098 25.1216 9.17858 25.3423 9.48663C25.5629 9.79467 25.7161 10.1462 25.7916 10.518L27.9972 10.0697C27.7715 8.95325 27.1689 7.94933 26.2911 7.22772C25.4134 6.50612 24.3145 6.11111 23.1803 6.10956Z"
      fill="#FFCB05"
    />
  </svg>
);
export default SVGComponent;